import { render, staticRenderFns } from "./registerModal.vue?vue&type=template&id=7b7ae4a6&scoped=true"
import script from "./registerModal.vue?vue&type=script&lang=js"
export * from "./registerModal.vue?vue&type=script&lang=js"
import style0 from "./registerModal.vue?vue&type=style&index=0&id=7b7ae4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ae4a6",
  null
  
)

export default component.exports